import { render, staticRenderFns } from "./CalendarEvent.vue?vue&type=template&id=51d7878c&"
import script from "./CalendarEvent.vue?vue&type=script&lang=js&"
export * from "./CalendarEvent.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEvent.vue?vue&type=style&index=0&id=51d7878c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports